// handleApiCall
export default (apiCallFunction, apiCallFunctionParams = {}) => {
  const controller = new AbortController();
  const params = Object.fromEntries(
    Object.entries(apiCallFunctionParams).filter(([_, value]) => value !== undefined && value !== null)
  );
  return {
    controller,
    run: () => apiCallFunction(params, controller.signal),
  };
};
